import React from 'react';
import AloDropdown, {
  DropdownItem,
  MUIAutocompletePropsType,
} from '../../_shared/ui-components/YogaUI/alo-ui/AloDropdown';
import { useSearchParamHelpers } from '../../_shared/react-hooks';
import { SORT_BY_KEY } from './sorting-utils';

type Value = { key: string; value?: string; text: string; className?: string } | undefined;

export const Sorting = ({
  value,
  dropdownItems,
  sortKey = SORT_BY_KEY,
  wrapperClass = '',
  MUIAutocompleteProps,
  labelPrefix,
  hasBorder,
}: {
  value: Value;
  dropdownItems: DropdownItem[];
  sortKey?: string;
  wrapperClass?: string;
  MUIAutocompleteProps?: MUIAutocompletePropsType;
  labelPrefix?: string;
  hasBorder?: boolean;
}) => {
  const { setSearchParams } = useSearchParamHelpers(window.location.search, { replace: true });
  return (
    <AloDropdown
      onChange={({ key }) => {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set(sortKey, key);
        setSearchParams(currentParams);
      }}
      placeholder="SORT"
      value={value}
      dropdownItems={dropdownItems}
      MUIAutocompleteProps={{
        closeIcon: false,
        blurOnSelect: true,
        selectOnFocus: false,
        openOnFocus: true,
        getOptionSelected: (option, value) => option.key === value.key,
        ...MUIAutocompleteProps,
      }}
      wrapperClass={`sorting ${wrapperClass}`}
      searchable
      inputReadOnly={true}
      labelPrefix={labelPrefix}
      hasBorder={hasBorder}
    />
  );
};
